import axios from './utils/axios';
import generateCRUDOps from './utils/generateCrud';

const pathPrefix = `/documents/`;

const SnapshotService = {
  ...generateCRUDOps(pathPrefix, 'snapshots'),

  getSnapshotsByDocId: async (id: number) => {
    return axios.get(`${pathPrefix}documents/${id}/snapshots/`);
  },
  markSnapshotAsPrimary: async (id: number, isFavorite: boolean) => {
    return axios.patch(`${pathPrefix}snapshots/${id}/`, {
      is_favorite: isFavorite,
    });
  },
  parseSnapshot: async (id: number, force: boolean = false) => {
    return axios.patch(`${pathPrefix}snapshots/${id}/parse/`, {
      force,
      provider: 'llama-parse',
    });
  },
  getParsedSnapshot: async (id: number) => {
    return axios.get(`${pathPrefix}snapshots/${id}/parsed/`);
  },
  text: async (id: number) => {
    return axios.get(`${pathPrefix}snapshots/${id}/text/`);
  },
};

export default SnapshotService;
